module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADOSURBVEiJ7dMxDoJAEAXQPwMVJRWNNzCGa1hwDzXxCFTcAU04BgXXsOAGNFtRGgt3xmJLg4nCEmL47STzsn8zBACn7X0TMOeAZgAlmDRqAKqtSFG2UUcOoxtA8bTQG9xb0TR0L4NnDAAoDphydjXOFc14+j/7FEp4PsxlBVdw+WA4NNgfglGLm6v9EjwOjkaBy6m0uTy9gHTePdTL5oH8/1ms4Ar+AqqZj1PDANXzgVSzFSkA7f1j2luRgss26qxoCqDyU68aAJUVTcs26l6VVULJMRi2MgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-canvas-table/images/checkheng.png
// module id = dx3i
// module chunks = 4